import { uhxVariantIds } from 'content/products/uhx/variantIds';
import { isM1UhxBundlingEnabled } from 'content/products/m1/m1UhxBundlingConfig';
import { ProductType } from 'components/shared/Cart/types';
import { isShopInternalPath } from 'lib/region/internalPath';
import { ONE_TIME_M1_OFFER } from 'lib/commerce/cart/campaignLinePresence';
import { CartPolicy } from './types';
import { getAttr, pass } from './cartLineHelpers';

function oneTimeShopAdd(input: Parameters<CartPolicy>[0]): boolean {
  return (input.lineItemsToAdd ?? []).some(
    (line) => getAttr(line.attributes, '_m1_offer') === ONE_TIME_M1_OFFER,
  );
}

export const uhxAutoAddPolicy: CartPolicy = (input, _cart, meta) => {
  // Membership from the shop must not bundle UHX. One-time shop adds opt in.
  const shopMembership =
    isShopInternalPath(meta.pagePath) && !oneTimeShopAdd(input);
  if (
    !meta.store ||
    !meta.discountOptions.isM1ProductTypePresent ||
    !meta.isCgmCampaignActive ||
    meta.ultrahumanXAdded ||
    !isM1UhxBundlingEnabled(meta.store) ||
    shopMembership
  ) {
    return pass(input);
  }

  const uhxVariantId = uhxVariantIds[meta.store]?.Year1;
  if (!uhxVariantId) return pass(input);

  meta.discountOptions.isUhxProductTypePresent = true;
  const lineItemsToAdd = [
    ...(input.lineItemsToAdd ?? []),
    {
      merchandiseId: uhxVariantId,
      quantity: 1,
      attributes: [{ key: '_product_type', value: ProductType.UHX }],
    },
  ];

  return {
    input: { ...input, lineItemsToAdd },
    reasons: ['auto-add UHX Year1 for active M1 campaign'],
  };
};
